import { ROUTE } from '../../../routes';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { StoreKey } from '../../../configs/api';
let phoneNumber = '';
export const accountDetails = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => { };
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    const routeId = await AsyncStorage.getItem(StoreKey.ROUTE_ID);
    if (routeId === ROUTE.DASHBOARD) {
        navigate(ROUTE.DASHBOARD);
    }
    else {
        goBack();
    }
};
